import { Component, OnInit } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { feedback } from '../../services/feedback/feedback.interface';
import { FeedbackService } from '../../services/feedback/feedback.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-feedback',
    imports: [
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatRadioModule,
    MatFormFieldModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule
],
    templateUrl: './feedback.component.html',
    styleUrl: './feedback.component.css'
})
export class FeedbackComponent implements OnInit {
  isLoading = false;

  form: FormGroup

  constructor(private fb: FormBuilder, private router: Router, private feedbackService: FeedbackService) {

  }
  ngOnInit(): void {
    this.form = this.fb.group({
        feedbackBody: [null, [Validators.maxLength(5000), Validators.required]],
    });
  }

  create(): void {
    if (this.form.invalid) {
      return;
    }
    this.isLoading = true;

    const newFeedback: feedback = {
      feedbackBody: this.form.controls['feedbackBody'].value as string,
    };
    this.feedbackService.createFeedback(newFeedback).subscribe(() => {
      this.router.navigate(['success']);
      this.isLoading = false;
    }, err => {
      console.error(err);
      this.isLoading = false;
    });
  }
}
